/* Maison Nathael — Tote bag offert (fonctionnement de l'ancien site, sécurisé).
   - Tant qu'aucun choix n'est dans le panier, un encadré propose : Crème / Noir / Je ne veux pas.
   - Le choix ajoute la variante correspondante du produit « Tote Bag Offert » (0 €) et l'encadré disparaît.
   - Pour changer d'avis, la cliente supprime la ligne : l'encadré réapparaît.
   - Protection : jamais plus d'UNE ligne tote bag (toutes variantes confondues), quantité 1,
     et pas de tote si le panier ne contient rien d'autre.
   - Le choix est obligatoire avant de passer commande. */
(function () {
  var VARIANTS = { 'Crème': 55896423268677, 'Noir': 55896423235909, 'Je ne veux pas': 55896423301445 };
  var TOTE_IDS = [VARIANTS['Crème'], VARIANTS['Noir'], VARIANTS['Je ne veux pas']];
  var OPTIONS = ['Crème', 'Noir', 'Je ne veux pas'];
  var CHECKOUT_SEL = 'button[name="checkout"], input[name="checkout"]';

  var hasChoice = false;
  var realCount = 0;
  var loaded = false;
  var busy = null;

  function api(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      cache: 'no-store'
    }).then(function (r) { return r.json(); });
  }

  function refreshThemeCart() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /* Met le panier en ordre ; renvoie true s'il a fallu le modifier. */
  function sanitize(cart) {
    var toteLines = cart.items.filter(function (it) { return TOTE_IDS.indexOf(it.variant_id) > -1; });
    var toteQty = toteLines.reduce(function (s, it) { return s + it.quantity; }, 0);
    realCount = (cart.item_count || 0) - toteQty;

    var updates = {};
    var keep = realCount > 0 ? toteLines[0] || null : null; /* on garde le premier choix */
    toteLines.forEach(function (it) {
      if (keep && it.key === keep.key) { if (it.quantity !== 1) updates[it.key] = 1; }
      else updates[it.key] = 0;
    });
    hasChoice = !!keep;

    var body = {};
    if (Object.keys(updates).length) body.updates = updates;
    if ((cart.attributes || {})['Tote bag offert']) body.attributes = { 'Tote bag offert': '' }; /* nettoyage d'un ancien essai */
    if (!body.updates && !body.attributes) return Promise.resolve(false);
    return api('/cart/update.js', body).then(function () { return !!body.updates; });
  }

  function loadCart() {
    if (busy) return busy;
    busy = api('/cart.js').then(function (cart) {
      return sanitize(cart).then(function (changed) {
        loaded = true;
        render();
        if (changed) refreshThemeCart();
      });
    }).catch(function () {}).then(function () { busy = null; });
    return busy;
  }

  function choose(label) {
    if (busy || !VARIANTS[label]) return;
    hasChoice = true;
    render();
    busy = api('/cart.js').then(function (cart) {
      var updates = {};
      cart.items.forEach(function (it) { if (TOTE_IDS.indexOf(it.variant_id) > -1) updates[it.key] = 0; });
      return Object.keys(updates).length ? api('/cart/update.js', { updates: updates }) : null;
    }).then(function () {
      return api('/cart/add.js', { items: [{ id: VARIANTS[label], quantity: 1 }] });
    }).catch(function () { hasChoice = false; }).then(function () {
      busy = null;
      render();
      refreshThemeCart();
    });
  }

  function buildBlock() {
    var box = document.createElement('div');
    box.className = 'mn-tote';
    var html = '<p class="mn-tote__title">Tote bag offert</p>' +
      '<p class="mn-tote__text">Choisissez votre couleur ou refusez-le pour éviter la surconsommation.</p>' +
      '<div class="mn-tote__opts">';
    OPTIONS.forEach(function (o) {
      html += '<button type="button" class="mn-tote__opt" data-value="' + o + '">' + o + '</button>';
    });
    html += '</div><p class="mn-tote__msg" role="alert" hidden>Merci de faire votre choix pour le tote bag avant de passer commande.</p>';
    box.innerHTML = html;
    return box;
  }

  function render() {
    if (!loaded) return;
    var pending = realCount > 0 && !hasChoice;
    document.documentElement.classList.toggle('mn-tote-pending', pending);

    document.querySelectorAll(CHECKOUT_SEL).forEach(function (btn) {
      var form = btn.form || btn.closest('form');
      if (!form) return;
      var block = form.querySelector('.mn-tote');
      if (pending && !block) {
        var host = btn.closest('.button-group') || btn;
        block = buildBlock();
        host.parentNode.insertBefore(block, host);
      }
      if (block && block.hidden !== !pending) block.hidden = !pending;
      if (btn.classList.contains('mn-tote-locked') !== pending) btn.classList.toggle('mn-tote-locked', pending);
      btn.setAttribute('aria-disabled', pending ? 'true' : 'false');
    });
  }

  function showMessage(btn) {
    var form = btn.form || btn.closest('form');
    var block = form && form.querySelector('.mn-tote');
    if (!block) return;
    block.querySelector('.mn-tote__msg').hidden = false;
    block.classList.add('mn-tote--alert');
    setTimeout(function () { block.classList.remove('mn-tote--alert'); }, 900);
    block.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('.mn-tote__opt');
    if (opt) {
      e.preventDefault();
      e.stopPropagation();
      choose(opt.getAttribute('data-value'));
      return;
    }
    var co = e.target.closest && e.target.closest(CHECKOUT_SEL);
    if (co && (busy || (realCount > 0 && !hasChoice))) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!busy) showMessage(co);
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (sub && sub.name === 'checkout' && (busy || (realCount > 0 && !hasChoice))) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!busy) showMessage(sub);
    }
  }, true);

  var timer = null;
  var observer = new MutationObserver(function (mutations) {
    var cartChanged = false;
    var needsRender = false;
    mutations.forEach(function (m) {
      var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      if (!el || !el.closest || el.closest('.mn-tote')) return;
      var touched = Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && !(n.classList && n.classList.contains('mn-tote')); }) ||
        Array.prototype.some.call(m.removedNodes, function (n) { return n.nodeType === 1 && !(n.classList && n.classList.contains('mn-tote')); });
      if (!touched) return;
      needsRender = true;
      if (el.closest('cart-drawer, .cart-page, cart-count, .header__cart-link')) cartChanged = true;
    });
    if (!needsRender) return;
    clearTimeout(timer);
    timer = setTimeout(function () { cartChanged ? loadCart() : render(); }, 300);
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    loadCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
